export const LangEnum = {
  Fr: 'fr',
  En: 'en',
}
